// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iSRM","left":"styles_left__1NqHD"};